const omit = (obj, keys) =>
  Object.keys(obj).reduce(
    (pre, cur) => !keys.includes(cur) && (pre[cur] = obj[cur]),
    {}
  );

export function xyReqHandle(res, self /*report | basic*/, type) {
  // 处理xyReqHandle逻辑
  const singleHandles = {
    highrisk: () => res.data && (self.report[type] = res.data.respDesc),
    risklabel: () => res.data && (self.report[type] = res.data),
    plinfp: () => res.data && (self.report[type] = res.data.resultDetails), // wait
    snxyp: () => (self.report[type] = res),
    zlengding: () => (self.report[type] = omit(res, ["isSuccess"])),
    trueman: () => (self.basic = res.data),
    basestatus: () => (self.basic = res.data),
    tanza: () => (self.report[type] = res.data),
    radar: () => (self.report[type] = res.data)
  };
  // console.log("处理中...")
  return singleHandles[type]
    ? singleHandles[type]()
    : console.error("未匹配到处理函数");
}

export const plf_map = {
  zxgg: [
    "zxggId",
    "address",
    "body",
    "caseNo",
    "closeDate",
    "court",
    "proposer",
    "sortTime",
    "title",
    "yjCode",
    "yjdw",
    "partys",
    "datatype"
  ],
  cpws: [
    "cpwsId",
    "body",
    "caseNo",
    "court",
    "judge",
    "judgeResult",
    "sortTime",
    "title",
    "yiju",
    "partys",
    "datatype"
  ],
  shixin: [
    "shixinId",
    "body",
    "caseNo",
    "court",
    "postTime",
    "sortTime",
    "yiwu",
    "yjCode",
    "yjdw",
    "partys",
    "datatype"
  ],
  sifacdk: [
    "sifacdkId",
    "body",
    "sortTime",
    "eventDate",
    "objectName",
    "court",
    "pname",
    "title",
    "action",
    "caseNo",
    "objectType",
    "postTime",
    "money",
    "dataType"
  ]
};

export default {
  D7: "7天",
  D30: "30天",
  D90: "90天",
  D180: "180天",
  D360: "360天",
  D540: "540天",
  D720: "720天",
  // basic
  date: "查询时间",
  type: "选项类型",
  type_name: "高级版报告V2",
  trueman_verify: "校验结果",
  trueman_result: "校验结果描述",
  telephone: "手机号",
  idcardno: "身份证",
  name: "姓名",
  phone_times: "手机号在网时长",
  phone_status: "手机号实时状态",
  phone_address: "手机号归属地",
  age: 26,
  idc_address: "江苏省宿迁市沭阳县",
  idcardno_attri: "身份证号初次发证地",
  sex: "性别",
  birthday: "生日",
  // 雷达
  c22180006: "网络贷款机构平均授信额度",
  c22180007: "消金贷款类机构数",
  c22180008: "消金贷款类产品数",
  c22180009: "消金贷款类机构最大授信额度",
  c22180002: "网贷额度置信度",
  c22180003: "网络贷款类机构数",
  c22180004: "网络贷款类产品数",
  c22180005: "网络贷款机构最大授信额度",
  c22180010: "消金贷款类机构平均授信额度",
  c22180011: "消金建议授信额度",
  c22180012: "消金额度置信度",
  c22180001: "网贷授信额度",
  b22170019: "近12个月贷款机构数",
  b22170050: "最近一次履约距今天数",
  b22170053: "信用贷款时长",
  b22170010: "近12个月贷款总金额",
  b22170054: "最近一次贷款放款时间",
  b22170051: "贷款行为置信度",
  b22170052: "贷款已结清订单数",
  b22170013: "近12个月贷款金额在1k-3k的笔数",
  b22170014: "近12个月贷款金额在3k-10k的笔数",
  b22170011: "近24个月贷款总金额",
  b22170012: "近12个月贷款金额在1k及以下的笔数",
  b22170017: "近3个月贷款机构数",
  b22170018: "近6个月贷款机构数",
  b22170015: "近12个月贷款金额在1w以上的笔数",
  b22170016: "近1个月贷款机构数",
  b22170020: "近24个月贷款机构数",
  b22170021: "近12个月消金类贷款机构数",
  b22170024: "近24个月网贷类贷款机构数",
  b22170025: "近6个月M0+逾期贷款笔数",
  b22170022: "近24个月消金类贷款机构数",
  b22170023: "近12个月网贷类贷款机构数",
  b22170028: "近6个月M1+逾期贷款笔数",
  b22170029: "近12个月M1+逾期贷款笔数",
  b22170026: "近12个月M0+逾期贷款笔数",
  b22170027: "近24个月M0+逾期贷款笔数",
  b22170031: "近6个月累计逾期金额",
  b22170032: "近12个月累计逾期金额",
  b22170030: "近24个月M1+逾期贷款笔数",
  b22170035: "近1个月失败扣款笔数",
  b22170036: "近3个月失败扣款笔数",
  b22170033: "近24个月累计逾期金额",
  b22170034: "正常还款订单数占贷款总订单数比例",
  b22170039: "近24个月失败扣款笔数",
  b22170037: "近6个月失败扣款笔数",
  b22170038: "近12个月失败扣款笔数",
  b22170008: "近3个月贷款总金额",
  b22170009: "近6个月贷款总金额",
  b22170042: "近6个月履约贷款总金额",
  b22170043: "近12个月履约贷款总金额",
  b22170040: "近1个月履约贷款总金额",
  b22170041: "近3个月履约贷款总金额",
  b22170002: "近1个月贷款笔数",
  b22170046: "近3个月履约贷款次数",
  b22170003: "近3个月贷款笔数",
  b22170047: "近6个月履约贷款次数",
  b22170044: "近24个月履约贷款总金额",
  b22170001: "贷款行为分",
  b22170045: "近1个月履约贷款次数",
  b22170006: "近24个月贷款笔数",
  b22170007: "近1个月贷款总金额",
  b22170004: "近6个月贷款笔数",
  b22170048: "近12个月履约贷款次数",
  b22170005: "近12个月贷款笔数",
  b22170049: "近24个月履约贷款次数",
  a22160009: "近3个月机构总查询笔数",
  a22160008: "近1个月机构总查询笔数",
  a22160007: "最近一次查询时间",
  a22160006: "机构总查询次数",
  a22160005: "申请命中网络贷款类机构数",
  a22160004: "申请命中消金类机构数",
  a22160003: "申请命中机构数",
  a22160002: "申请准入置信度",
  a22160001: "申请准入分",
  a22160010: "近6个月机构总查询笔数",
  // label: "当前逾期",
  currently_overdue: "当前逾期机构数",
  acc_sleep: "睡眠机构数",
  currently_performance: "当前履约机构数",
  result_code: "探查结果编码",
  acc_exc: "异常还款机构数",
  // 黑名单
  pid: "身份证维度",
  mobile: "手机号维度",
  home_phone: "家庭电话维度",
  home_address: "家庭地址维度",
  deviceId: "设备ID维度",
  blackLevel: "黑名单类型",
  last6MTenantCount: "最近6个月确认为黑名单的机构数",
  last6MQueryCount: "最近6个月申请查询数",
  lastConfirmAtDays: "最新入库距离天数",
  lastConfirmStatus: "最新欺诈／逾期状态",
  last12MMaxConfirmStatus: "最近12个月最严重逾期状态",
  loanTypes: "贷款类型列表",
  // 多头监控
  loanTypes: "贷款类型列表",
  tenantTypes: "机构类型列表",
  totalAppsCount: "总申请次数",
  totalcrossTenantAppsCount: "总申请机构数",
  averageLoanGapDays: "平均申请间隔时长",
  averageTenantGapDays: "平均换新",
  totalmobileCount: "总手机号数",
  Banks: "银行类",
  totalAppsNumber: "申请数",
  crossTenantAppsNumber: "申请机构数",
  mobileCount: "手机号数",
  pidCount: "身份证号数",
  "Non-bankFin": "非银行持牌类",
  Others: "其他类",
  // 借贷履约
  xyp_t01aazhzz: "最近360天新增机构 _交易⾦额_最⼤值",
  xyp_t01abdzbz: "近21天_⼩贷担保类_交易⾦额_最⼩值",
  xyp_t01aahzbz: "近360天_⼩贷担保类_交易⾦额_最⼤值",
  xyp_t01ackzbz: "近50次交易_⼩贷担保类_交易⾦额_求和",
  xyp_t01cczgbc: "最近180天新增机构 _⼩贷担保类_还款成功_笔数_求和",
  xyp_t01adjzzz: "近20次交易_交易⾦额_平均值",
  xyp_t01adzfbz: "最近90天新增机构 _⼩贷担保类_交易⾦额_平均值",
  xyp_model_score_mid: "⼩额分期分V1 范围是[350,950],越⼤逾期率越低,未命中为-1",
  xyp_t01acizza: "近5次交易_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t01adjzzc: "近20次交易_还款成功_还款⾦额_平均值",
  xyp_t01aakzzz: "近50次交易_交易⾦额_最⼤值",
  xyp_t02cchzza_cchzzz:
    "近360天_因交易能⼒不⾜导致失败_笔数_求和/近360天_笔数_求和",
  xyp_t01acfzbc: "近90天_⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t02cchzzc_cchzzz: "近360天_还款成功_笔数_求和/近360天_笔数_求和",
  xyp_t01abgzzc: "近180天_还款成功_还款⾦额_最⼩值",
  xyp_t01degzbc: "近180天_⼩贷担保类_还款成功_机构数_去重计数",
  xyp_t01dejzzc: "近20次交易_还款成功_机构数_去重计数",
  xyp_t02cckzbc_cckzbz:
    "近50次交易_⼩贷担保类_还款成功_笔数_求和/近50次交易_⼩贷担保类_笔数_求和",
  xyp_t01cclzba: "近100次交易_⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t01ackzaz: "近50次交易_消费⾦融类_交易⾦额_求和",
  xyp_t01cclzbc: "近100次交易_⼩贷担保类_还款成功_笔数_求和",
  xyp_t01aafzzc: "近90天_还款成功_还款⾦额_最⼤值",
  xyp_t01aazgzc: "最近180天新增机构 _还款成功_还款⾦额_最⼤值",
  xyp_t01adgzbc: "近180天_⼩贷担保类_还款成功_还款⾦额_平均值",
  xyp_t01abjzbc: "近20次交易_⼩贷担保类_还款成功_还款⾦额_最⼩值",
  xyp_t03td148: "最近⼀次交易为交易失败机构数",
  xyp_t01adgzba: "近180天_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_平均值",
  xyp_t01delzbc: "近100次交易_⼩贷担保类_还款成功_机构数_去重计数",
  xyp_t01aafzzz: "近90天_交易⾦额_最⼤值",
  xyp_t01abzfzz: "最近90天新增机构 _交易⾦额_最⼩值",
  xyp_t02acizba_aczzba:
    "近5次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和/⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t01aczhbc: "最近360天新增机构 _⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t01acczzz: "近14天_交易⾦额_求和",
  xyp_t01aczgbz: "最近180天新增机构 _⼩贷担保类_交易⾦额_求和",
  xyp_t03td053: "最近180天_⼩贷担保类_交易失败次数>0的机构数",
  xyp_t01ccgzbc: "近180天_⼩贷担保类_还款成功_笔数_求和",
  xyp_t02achzza_achzzz:
    "近360天_因交易能⼒不⾜导致失败_交易⾦额_求和/近360天_交易⾦额_求和",
  xyp_var9: "保留字",
  xyp_var8: "保留字",
  xyp_t01adhzbc: "近360天_⼩贷担保类_还款成功_还款⾦额_平均值",
  xyp_var7: "保留字",
  xyp_t02ackzbc_ackzbz:
    "近50次交易_⼩贷担保类_还款成功_还款⾦额_求和/近50次交易⼩贷担保类_交易⾦额_求和",
  xyp_t01aalzzc: "近100次交易_还款成功_还款⾦额_最⼤值",
  xyp_t01defzbz: "近90天_⼩贷担保类_机构数_去重计数",
  xyp_t02ccgzzc_ccgzzz: "近180天_还款成功_笔数_求和/近180天_笔数_求和",
  xyp_t01acdzzz: "近21天_交易⾦额_求和",
  xyp_t01aaizba: "近5次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_最⼤值",
  xyp_t02acfzza_acfzzz:
    "近90天_因交易能⼒不⾜导致失败_交易⾦额_求和/近90天_交易⾦额_求和",
  xyp_t01aclzbc: "近100次交易_⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t02achzbc_achzbz:
    "近360天_⼩贷担保类_还款成功_还款⾦额_求和/近360天_⼩贷担保类_交易⾦额_求和",
  xyp_t01aaizbz: "近5次交易_⼩贷担保类_交易⾦额_最⼤值",
  xyp_t02ccizbc_cczzbc:
    "近5次交易_⼩贷担保类_还款成功_笔数_求和/⼩贷担保类_还款成功_笔数_求和",
  xyp_t02acizbc_acizbz:
    "近5次交易_⼩贷担保类_还款成功_还款⾦额_求和/近5次交易_ ⼩贷担保类_交易⾦额_求和",
  xyp_t01aazfzc: "最近90天新增机构 _还款成功_还款⾦额_最⼤值",
  xyp_t03td045: "最近90天_⼩贷担保类_交易失败次数>0的机构数",
  xyp_t01abezbz: "近30天_⼩贷担保类_交易⾦额_最⼩值",
  xyp_t02acjzbc_acjzbz:
    "近20次交易_⼩贷担保类_还款成功_还款⾦额_求和/近20次交易_⼩贷担保类_交易⾦额_求和",
  xyp_var6: "保留字",
  xyp_t01acizzz: "近5次交易_交易⾦额_求和",
  xyp_t01cczfbz: "最近90天新增机构 _⼩贷担保类_笔数_求和",
  xyp_var5: "保留字",
  xyp_var4: "保留字",
  xyp_var3: "保留字",
  xyp_var2: "保留字",
  xyp_var1: "保留字",
  xyp_t01acfzbz: "近90天_⼩贷担保类_交易⾦额_求和",
  xyp_t02cczzza_cczzzz: "因交易能⼒不⾜导致失败_笔数_求和/笔数_求和",
  xyp_t02ccfzbc_cczzbc:
    "近90天_⼩贷担保类_还款成功_笔数_求和/⼩贷担保类_还款成功_笔数_求和",
  xyp_t01bbzzza: "因交易能⼒不⾜导致失败_交易距离当前天数_最⼩值",
  xyp_t01aczgbc: "最近180天新增机构 _⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t01cczzzz: "笔数_求和",
  xyp_t01aalzzz: "近100次交易_交易⾦额_最⼤值",
  xyp_t01aazfzz: "最近90天新增机构 _交易⾦额_最⼤值",
  xyp_t01adzgzc: "最近180天新增机构 _还款成功_还款⾦额_平均值",
  xyp_t01adczbz: "近14天_⼩贷担保类_交易⾦额_平均值",
  xyp_t01aczfbz: "最近90天新增机构 _⼩贷担保类_交易⾦额_求和",
  xyp_cpl0058: "⼩贷担保类_交易失败向后距离下⼀次还款成功的天数最⼩值",
  xyp_t01aczzzz: "交易⾦额_求和",
  xyp_t01adfzzz: "近90天_交易⾦额_平均值",
  xyp_cpl0059: "交易失败向后距离下⼀次还款成功的天数最⼩值",
  xyp_t01cczezz: "最近30天新增机构 _笔数_求和",
  xyp_t03td111: "最近90天_交易失败次数>0的机构数",
  xyp_t01aagzzc: "近180天_还款成功_还款⾦额_最⼤值",
  xyp_cpl0056: "交易失败向后距离下⼀次还款成功的天数最⼤值",
  xyp_t02acfzbc_aczzbc:
    "近90天_⼩贷担保类_还款成功_还款⾦额_求和/⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_cpl0057: "消费⾦融类_交易失败向后距离下⼀次还款成功的天数最⼩值",
  xyp_t01bazzba: "⼩贷担保类_因交易能⼒不⾜导致失败_交易距离当前天数_最⼤值",
  xyp_t02cchzba_cchzbz:
    "近360天_⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和/近360天_⼩贷担保类_笔数_求和",
  xyp_t01abkzbc: "近50次交易_⼩贷担保类_还款成功_还款⾦额_最⼩值",
  xyp_t01bazzbc: "小贷担保类_还款成功_交易距离当前天数_最⼤值",
  xyp_t03td115: "最近180天_交易失败次数>0的机构数",
  xyp_t01abkzba:
    "近50次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_ 最⼩值",
  xyp_cpl0050: "最近21天_交易失败次数>0的机构数",
  xyp_cpl0051: "最近30天_交易失败次数>0的机构数",
  xyp_t01adfzzc: "近90天_还款成功_还款⾦额_平均值",
  xyp_cpl0054: "消费⾦融类_交易失败向后距离下⼀次还款成功的天数最⼤值",
  xyp_t01bazzbz: "小贷担保类_交易距离当前天数_最⼤值",
  xyp_cpl0055: "⼩贷担保类_交易失败向后距离下⼀次还款成功的天数最⼤值",
  xyp_cpl0052: "消费⾦融类最后⼀次交易失败后还款次数",
  xyp_t01dekzzz: "近50次交易_机构数_去重计数",
  xyp_cpl0053: "⼩贷担保类最后⼀次交易失败后还款次数",
  xyp_t01adfzza: "近90天_因交易能⼒不⾜导致失败_交易⾦额_平均值",
  xyp_t01aadzbz: "近21天_⼩贷担保类_交易⾦额_最⼤值",
  xyp_t01acjzzz: "近20次交易_交易⾦额_求和",
  xyp_t02cclzba_cclzbz:
    "近100次交易_⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和/近100次交易_⼩贷担保类_笔数_求和",
  xyp_t01abfzba: "近90天_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_最⼩值",
  xyp_t01aclzbz: "近100次交易_⼩贷担保类_交易⾦额_求和",
  xyp_cpl0069: "最后⼀次交易失败后还款次数",
  xyp_cpl0067: "最近21天还款成功总⾦额",
  xyp_cpl0068: "最近⼀次还款成功距离当前天数",
  xyp_cpl0061: "⼩贷担保类_交易失败向后距离下⼀次还款成功的天数平均值",
  xyp_cpl0062: "交易失败向后距离下⼀次还款成功的天数平均值",
  xyp_t01cchzzc: "近360天_还款成功_笔数_求和",
  xyp_cpl0060: "消费⾦融类_交易失败向后距离下⼀次还款成功的天数平均值",
  xyp_model_score_high:
    "⼩额⽹贷分V1 范围是[350,950],越⼤逾期率越低,未命中为-1",
  xyp_cpl0065: "最近21交易失败笔数",
  xyp_cpl0066: "最近21天交易失败总⾦额",
  xyp_t01abkzbz: "近50次交易_⼩贷担保类_交易⾦额_最⼩值",
  xyp_cpl0063: "最近21天贷款机构数",
  xyp_t01adkzzc: "近50次交易_还款成功_还款⾦额_平均值",
  xyp_cpl0064: "最近21天还款成功笔数",
  xyp_t01aajzba: "近20次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_最⼤值",
  xyp_t01aczfbc: "最近90天新增机构 _⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t01acgzbc: "近180天_⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t01dekzzc: "近50次交易_还款成功_机构数_去重计数",
  xyp_t01aczfba:
    "最近90天新增机构 _⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t01aczzzc: "还款成功_还款⾦额_求和",
  xyp_t01adzfzc: "最近90天新增机构 _还款成功_还款⾦额_平均值",
  xyp_t01adizbz: "近5次交易_⼩贷担保类_交易⾦额_平均值",
  xyp_cpl0078: "近20次还款中还款成功总⾦额",
  xyp_t02dezgzz_dezzzz: "最近180天新增机构 _机构数_去重计数/机构数_去重计数",
  xyp_t01abfzbz: "近90天_⼩贷担保类_交易⾦额_最⼩值",
  xyp_cpl0079: "近90天内还款成功总⾦额/近90天还款总⾦额",
  xyp_t02achzzc_achzzz: "近360天_还款成功_还款⾦额_求和/近360天_交易⾦额_求和",
  xyp_t01ccczza: "近14天_因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t01cczhbc: "最近360天新增机构 _⼩贷担保类_还款成功_笔数_求和",
  xyp_cpl0072: "当前逾期⾦额",
  xyp_cpl0073: "近5次还款中成功还款总⾦额/近5次还款总⾦额",
  xyp_t01aaezbc: "近30天_⼩贷担保类_还款成功_还款⾦额_最⼤值",
  xyp_t01aczhzc: "最近360天新增机构 _还款成功_还款⾦额_求和",
  xyp_cpl0070: "最近1天贷款机构数",
  xyp_cpl0071: "当前逾期机构数",
  xyp_cpl0076: "近20次还款中还款成功笔数",
  xyp_t01ackzza: "近50次交易_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_cpl0077: "近5次还款中还款成功总⾦额",
  xyp_t01aahzza: "近360天_因交易能⼒不⾜导致失败_交易⾦额_最⼤值",
  xyp_t01achzaz: "近360天_消费⾦融类_交易⾦额_求和",
  xyp_cpl0074: "近5次还款中还款成功笔数/近5次还款总笔数",
  xyp_t01ackzzc: "近50次交易_还款成功_还款⾦额_求和",
  xyp_cpl0075:
    "近20次还款中⼩贷担保类还款成功笔数/近20次还款中⼩贷担保类还款笔数",
  xyp_t02acezza_aczzza:
    "近30天_因交易能⼒不⾜导致失败_交易⾦额_求和/因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t01abizzc: "近5次交易_还款成功_还款⾦额_最⼩值",
  xyp_t01achzbc: "近360天_⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t01cckzaz: "近50次交易_消费⾦融类_笔数_求和",
  xyp_t01adlzzc: "近100次交易_还款成功_还款⾦额_平均值",
  xyp_t02cczzba_cczzbz:
    "⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和/⼩贷担保类_ 笔数_求和",
  xyp_t01ccfzbc: "近90天_⼩贷担保类_还款成功_笔数_求和",
  xyp_t02ccfzzc_cczzzc: "近90天_还款成功_笔数_求和/还款成功_笔数_求和",
  xyp_t01adizbc: "近5次交易_⼩贷担保类_还款成功_还款⾦额_平均值",
  xyp_t01ccizza: "近5次交易_因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t01ablzbc: "近100次交易_⼩贷担保类_还款成功_还款⾦额_最⼩值",
  xyp_t01ccizzc: "近5次交易_还款成功_笔数_求和",
  xyp_cpl0083: "履约笔数综合指数取值范围在 0-1之间指数越⼤⽤户逾期可能性越⾼",
  xyp_cpl0081: "信⽤风险评分取值范围在0-1之间分数越⾼⽤户信⽤越低",
  xyp_cpl0082: "履约⾦额综合指数0-1之间指数越⼤⽤户逾期可能性越⾼",
  xyp_t02acjzzc_acjzzz:
    "近20次交易_还款成功_还款⾦额_求和/近20次交易_交易⾦额_求和",
  xyp_t01acezzz: "近30天_交易⾦额_求和",
  xyp_t02ackzzc_ackzzz:
    "近50次交易_还款成功_还款⾦额_求和/近50次交易_交易⾦额_求和",
  xyp_cpl0080: "近90天内还款成功笔数/近90天内还款总笔数",
  xyp_t02aclzzc_aclzzz:
    "近100次交易_还款成功_还款⾦额_求和/近100次交易_交易⾦额_求和",
  xyp_t01degzzc: "近180天_还款成功_机构数_去重计数",
  xyp_t02ccezzc_cczzzc: "近30天_还款成功_笔数_求和/还款成功_笔数_求和",
  xyp_t01adjzba:
    "近20次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_ 平均值",
  xyp_t02ccfzba_ccfzbz:
    "近90天_⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和/近90天_⼩贷担保类_笔数_求和",
  xyp_t01abgzbc: "近180天_⼩贷担保类_还款成功_还款⾦额_最⼩值",
  xyp_t01acfzza: "近90天_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t01abjzzc: "近20次交易_还款成功_还款⾦额_最⼩值",
  xyp_t02ccfzbc_ccfzbz:
    "近90天_⼩贷担保类_还款成功_笔数_求和/近90天_⼩贷担保类_ 笔数_求和",
  xyp_t02ccezza_cczzza:
    "近30天_因交易能⼒不⾜导致失败_笔数_求和/因交易能⼒不⾜导致失败_笔数_求和",
  xyp_cpl0014: "历史贷款机构成功还款笔数",
  xyp_cpl0015: "历史贷款机构交易失败笔数",
  xyp_cpl0012: "最近90天贷款机构数",
  xyp_t01bbzzbz: "⼩贷担保类_交易距离当前天数_最⼩值",
  xyp_t01abzfbz: "最近90天新增机构 _⼩贷担保类_交易⾦额_最⼩值",
  xyp_t01cczgzz: "最近180天新增机构 _笔数_求和",
  xyp_cpl0013: "最近180天贷款机构数",
  xyp_cpl0018: "最近7天交易失败笔数",
  xyp_t02acezba_acezbz:
    "近30天_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和/近30天_⼩贷担保类_交易⾦额_求和",
  xyp_cpl0019: "最近7天还款成功笔数",
  xyp_cpl0016: "最近1天交易失败笔数",
  xyp_t01adjzbc: "近20次交易_⼩贷担保类_还款成功_还款⾦额_平均值",
  xyp_t01cclzzc: "近100次交易_还款成功_笔数_求和",
  xyp_cpl0017: "最近1天还款成功笔数",
  xyp_t01bbzzbc: "⼩贷担保类_还款成功_交易距离当前天数_最⼩值",
  xyp_t01bbzzba: "⼩贷担保类_因交易能⼒不⾜导致失败_交易距离当前天数_最⼩值",
  xyp_t01aczgzc: "最近180天新增机构 _还款成功_还款⾦额_求和",
  xyp_t01aczgza: "最近180天新增机构 _因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_cpl0010: "最近14贷款机构数",
  xyp_cpl0011: "最近30天贷款机构数",
  xyp_t01adzzba: "⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_平均值",
  xyp_t01aakzba:
    "近50次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_ 最⼤值",
  xyp_t01aazhaz: "最近360天新增机构 _消费⾦融类_交易⾦额_最⼤值",
  xyp_t01cczfza: "最近90天新增机构 _因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t01addzbz: "近21天_⼩贷担保类_交易⾦额_平均值",
  xyp_t01cczfzc: "最近90天新增机构 _还款成功_笔数_求和",
  xyp_model_score_low:
    "中⼤额分期分V1 范围是[350,950],越⼤逾期率越低,未命中为-1",
  xyp_cpl0025: "最近90天还款成功笔数",
  xyp_cpl0026: "最近180天交易失败笔数",
  xyp_cpl0023: "最近30天还款成功笔数",
  xyp_cpl0024: "最近90天交易失败笔数",
  xyp_t01abzzza: "因交易能⼒不⾜导致失败_交易⾦额_最⼩值",
  xyp_cpl0029: "最近7天是否发⽣过逾期",
  xyp_t02acczza_acczzz:
    "近14天_因交易能⼒不⾜导致失败_交易⾦额_求和/近14天_交易⾦额_求和",
  xyp_cpl0027: "最近180天还款成功笔数",
  xyp_t01ccgzza: "近180天_因交易能⼒不⾜导致失败_笔数_求和",
  xyp_cpl0028: "最近1天是否发⽣过逾期",
  xyp_t01aafzbc: "近90天_⼩贷担保类_还款成功_还款⾦额_最⼤值",
  xyp_t01abzfba:
    "最近90天新增机构 _⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_最⼩值",
  xyp_t01adgzzc: "近180天_还款成功_还款⾦额_平均值",
  xyp_t01aaizzc: "近5次交易_还款成功_还款⾦额_最⼤值",
  xyp_cpl0021: "最近14天还款成功笔数",
  xyp_cpl0022: "最近30天交易失败笔数",
  xyp_t01achzbz: "近360天_⼩贷担保类_交易⾦额_求和",
  xyp_t01adgzza: "近180天_因交易能⼒不⾜导致失败_交易⾦额_平均值",
  xyp_cpl0020: "最近14天交易失败笔数",
  xyp_t01aazhbz: "最近360天新增机构 _⼩贷担保类_交易⾦额_最⼤值",
  xyp_t01ackzzz: "近50次交易_交易⾦额_求和",
  xyp_t02acfzzc_aczzzc: "近90天_还款成功_还款⾦额_求和/还款成功_还款⾦额_求和",
  xyp_t01ccgzzz: "近180天_笔数_求和",
  xyp_cpl0036: "最近14天交易失败总⾦额",
  xyp_cpl0037: "最近14天还款成功总⾦额",
  xyp_cpl0034: "最近7天交易失败总⾦额",
  xyp_t02ccgzba_ccgzbz:
    "近180天_⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和/近180天_⼩贷担保类_笔数_求和",
  xyp_cpl0035: "最近7天还款成功总⾦额",
  xyp_cpl0038: "最近30天交易失败总⾦额",
  xyp_cpl0039: "最近30天还款成功总⾦额",
  xyp_t01aczfzc: "最近90天新增机构 _还款成功_还款⾦额_求和",
  xyp_cpl0032: "最近1天交易失败总⾦额",
  xyp_t01aczfza: "最近90天新增机构 _因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_cpl0033: "最近1天还款成功总⾦额",
  xyp_cpl0030: "最近14天是否发⽣过逾期",
  xyp_cpl0031: "最近30天是否发⽣过逾期",
  xyp_t01acizbz: "近5次交易_⼩贷担保类_交易⾦额_求和",
  xyp_t01delzzc: "近100次交易_还款成功_机构数_去重计数",
  xyp_t01dezgzz: "最近180天新增机构 _机构数_去重计数",
  xyp_t01aaizzz: "近5次交易_交易⾦额_最⼤值",
  xyp_t01aafzbz: "近90天_⼩贷担保类_交易⾦额_最⼤值",
  xyp_t01aclzzz: "近100次交易_交易⾦额_求和",
  xyp_t02ccezba_ccezbz:
    "近30天_⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和/近30天_⼩贷担保类_笔数_求和",
  xyp_t01abhzbc: "近360天_⼩贷担保类_还款成功_还款⾦额_最⼩值",
  xyp_t02ccfzza_cczzza:
    "近90天_因交易能⼒不⾜导致失败_笔数_求和/因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t01ccjzbc: "近20次交易_⼩贷担保类_还款成功_笔数_求和",
  xyp_t01abkzza: "近50次交易_因交易能⼒不⾜导致失败_交易⾦额_最⼩值",
  xyp_t01bbzzaz: "消费⾦融类_交易距离当前天数_最⼩值",
  xyp_cpl0048: "最近7天_交易失败次数>0的机构数",
  xyp_cpl0045: "信⽤贷款时长",
  xyp_cpl0046: "最近⼀次交易距离当前时间",
  xyp_t02acdzza_aczzza:
    "近21天_因交易能⼒不⾜导致失败_交易⾦额_求和/因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_cpl0049: "最近14天_交易失败次数>0的机构数",
  xyp_cpl0040: "最近90天交易失败总⾦额",
  xyp_t01acizbc: "近5次交易_⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t01ccbzzz: "近7天_笔数_求和",
  xyp_cpl0043: "最近180天还款成功总⾦额",
  xyp_cpl0044: "当前是否存在逾期未结清",
  xyp_cpl0041: "最近90天还款成功总⾦额",
  xyp_t02acfzbc_acfzbz:
    "近90天_⼩贷担保类_还款成功_还款⾦额_求和/近90天_⼩贷担保类_交易⾦额_求和",
  xyp_cpl0042: "最近180天交易失败总⾦额",
  xyp_t01aclzzc: "近100次交易_还款成功_还款⾦额_求和",
  xyp_t01aalzbc: "近100次交易_⼩贷担保类_还款成功_还款⾦额_最⼤值",
  xyp_t02ackzza_ackzzz:
    "近50次交易_因交易能⼒不⾜导致失败_交易⾦额_求和/近50次交易_交易⾦额_求和",
  xyp_t01aczgzz: "最近180天新增机构 _交易⾦额_求和",
  xyp_t02acgzbc_acgzbz:
    "近180天_⼩贷担保类_还款成功_还款⾦额_求和/近180天_⼩贷担保类_交易⾦额_求和",
  xyp_t01ccjzaz: "近20次交易_消费⾦融类_笔数_求和",
  xyp_t01acizba: "近5次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t01cczzbc: "⼩贷担保类_还款成功_笔数_求和",
  xyp_t02aclzza_aclzzz:
    "近100次交易_因交易能⼒不⾜导致失败_交易⾦额_求和/近100次交易_交易⾦额_求和",
  xyp_t01aazfbc: "最近90天新增机构 _⼩贷担保类_还款成功_还款⾦额_最⼤值",
  xyp_t01aalzbz: "近100次交易_⼩贷担保类_交易⾦额_最⼤值",
  xyp_t01aczzbc: "⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t01ccezzz: "近30天_笔数_求和",
  xyp_t01aczzaz: "消费⾦融类_交易⾦额_求和",
  xyp_t02dezfzz_dezzzz: "最近90天新增机构 _机构数_去重计数/机构数_去重计数",
  xyp_t01aajzza: "近20次交易_因交易能⼒不⾜导致失败_交易⾦额_最⼤值",
  xyp_t01acjzbc: "近20次交易_⼩贷担保类_还款成功_还款⾦额_求和",
  xyp_t02aclzba_aclzbz:
    "近100次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和/近100次交易_⼩贷担保类_交易⾦额_求和",
  xyp_t01aajzzc: "近20次交易_还款成功_还款⾦额_最⼤值",
  xyp_t01dekzbc: "近50次交易_⼩贷担保类_还款成功_机构数_去重计数",
  xyp_t02aclzbc_aclzbz:
    "近100次交易_⼩贷担保类_还款成功_还款⾦额_求和/近100次交易_⼩贷担保类_交易⾦额_求和",
  xyp_t01acjzaz: "近20次交易_消费⾦融类_交易⾦额_求和",
  xyp_t01dezhba:
    "最近360天新增机构 _⼩贷担保类_因交易能⼒不⾜导致失败_机构数_去重计数",
  xyp_t01aagzaz: "近180天_消费⾦融类_交易⾦额_最⼤值",
  xyp_t01acbzzz: "近7天_交易⾦额_求和",
  xyp_t01ccbzbz: "近7天_⼩贷担保类_笔数_求和",
  xyp_t01abzgza: "最近180天新增机构 _因交易能⼒不⾜导致失败_交易⾦额_最⼩值",
  xyp_t02ccezba_cczzba:
    "近30天_⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和/⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t02ccizza_cczzza:
    "近5次交易_因交易能⼒不⾜导致失败_笔数_求和/因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t01aazzzc: "还款成功_还款⾦额_最⼤值",
  xyp_t01abzgzc: "最近180天新增机构 _还款成功_还款⾦额_最⼩值",
  xyp_t01acjzba: "近20次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t02ccizzc_cczzzc: "近5次交易_还款成功_笔数_求和/还款成功_笔数_求和",
  xyp_t01dezhbc: "最近360天新增机构 _⼩贷担保类_还款成功_机构数_去重计数",
  xyp_t01cchzaz: "近360天_消费⾦融类_笔数_求和",
  xyp_t01abfzzz: "近90天_交易⾦额_最⼩值",
  xyp_t01cczhza: "最近360天新增机构 _因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t03td061: "最近360天_⼩贷担保类_交易失败次数>0的机构数",
  xyp_t01cczhzc: "最近360天新增机构 _还款成功_笔数_求和",
  xyp_t01acgzza: "近180天_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t02aczzza_aczzzz: "因交易能⼒不⾜导致失败_交易⾦额_求和/交易⾦额_求和",
  xyp_t01cchzbc: "近360天_⼩贷担保类_还款成功_笔数_求和",
  xyp_t02acizza_aczzza:
    "近5次交易_因交易能⼒不⾜导致失败_交易⾦额_求和/因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t01adkzbc: "近50次交易_⼩贷担保类_还款成功_还款⾦额_平均值",
  xyp_t01cckzzc: "近50次交易_还款成功_笔数_求和",
  xyp_t02cchzbc_cchzbz:
    "近360天_⼩贷担保类_还款成功_笔数_求和/近360天_⼩贷担保类_笔数_求和",
  xyp_t01acdzbz: "近21天_⼩贷担保类_交易⾦额_求和",
  xyp_t01abfzza: "近90天_因交易能⼒不⾜导致失败_交易⾦额_最⼩值",
  xyp_t01aagzbz: "近180天_⼩贷担保类_交易⾦额_最⼤值",
  xyp_t01abfzzc: "近90天_还款成功_还款⾦额_最⼩值",
  xyp_t01aczfzz: "最近90天新增机构 _交易⾦额_求和",
  xyp_t02dezezz_dezzzz: "最近30天新增机构 _机构数_去重计数/机构数_去重计数",
  xyp_t01acgzzz: "近180天_交易⾦额_求和",
  xyp_t01achzzc: "近360天_还款成功_还款⾦额_求和",
  xyp_t01cczhzz: "最近360天新增机构 _笔数_求和",
  xyp_t02ccgzbc_ccgzbz:
    "近180天_⼩贷担保类_还款成功_笔数_求和/近180天_⼩贷担保类_笔数_求和",
  xyp_t01dejzbz: "近20次交易_⼩贷担保类_机构数_去重计数",
  xyp_t02ccgzza_ccgzzz:
    "近180天_因交易能⼒不⾜导致失败_笔数_求和/近180天_笔数_求和",
  xyp_t01acezbz: "近30天_⼩贷担保类_交易⾦额_求和",
  xyp_var10: "保留字",
  xyp_t01abzfzc: "最近90天新增机构 _还款成功_还款⾦额_最⼩值",
  xyp_t01aabzbz: "近7天_⼩贷担保类_交易⾦额_最⼤值",
  xyp_t01adfzbz: "近90天_⼩贷担保类_交易⾦额_平均值",
  xyp_t01cczgza: "最近180天新增机构 _因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t02acizba_acizbz:
    "近5次交易_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和/近5次交易_⼩贷担保类_交易⾦额_求和",
  xyp_t01cczgzc: "最近180天新增机构 _还款成功_笔数_求和",
  xyp_cpl0009: "最近7天贷款机构数",
  xyp_t0400004: "近100次还款_还款成功_笔数_求和/近100次还款_笔数_求和",
  xyp_t01bazzza: "因交易能⼒不⾜导致失败_交易距离当前天数_最⼤值",
  xyp_t0400003: "近50次还款_还款成功_笔数_求和/近50次还款_笔数_求和",
  xyp_t0400002: "近20次还款_还款成功_笔数_求和/近20次还款_笔数_求和",
  xyp_t01bazzzc: "还款成功_交易距离当前天数_最⼤值",
  xyp_t01acjzbz: "近20次交易_⼩贷担保类_交易⾦额_求和",
  xyp_t01ccfzzz: "近90天_笔数_求和",
  xyp_cpl0001: "贷款总机构数",
  xyp_t01adzgbc: "最近180天新增机构 _⼩贷担保类_还款成功_还款⾦额_平均值",
  xyp_cpl0002: "贷款已结清机构数",
  xyp_cpl0007: "消费⾦融类机构数",
  xyp_cpl0008: "⽹络贷款类机构数",
  xyp_t01adizzz: "近5次交易_交易⾦额_平均值",
  xyp_t01aazhzc: "最近360天新增机构 _还款成功_还款⾦额_最⼤值",
  xyp_t01adizzc: "近5次交易_还款成功_还款⾦额_平均值",
  xyp_t01dejzbc: "近20次交易_⼩贷担保类_还款成功_机构数_去重计数",
  xyp_t01abizbz: "近5次交易_⼩贷担保类_交易⾦额_最⼩值",
  xyp_t02acfzba_acfzbz:
    "近90天_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和/近90天_⼩贷担保类_交易⾦额_求和",
  xyp_t02cczzzc_cczzzz: "还款成功_笔数_求和/笔数_求和",
  xyp_t02ccfzba_cczzba:
    "近90天_⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和/⼩贷担保类_因交易能⼒不⾜导致失败_笔数_求和",
  xyp_t02acgzba_acgzbz:
    "近180天_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和/近180天_⼩贷担保类_交易⾦额_求和",
  xyp_t01acezba: "近30天_⼩贷担保类_因交易能⼒不⾜导致失败_交易⾦额_求和",
  xyp_t01aczezz: "最近30天新增机构 _交易⾦额_求和",
  // 风险标签
  BQ01: "中介风险",
  BQ02: "黄赌毒风险",
  BQ03: "虚假资料风险",
  BQ04: "羊毛党风险",
  BQ05: "身份欺诈风险",
  BQ06: "失信风险",
  BQ07: "黑产风险",
  BQ08: "手机号码风险",
  BQ09: "设备风险",
  BQ10: "多贷风险",
  BQ11: "支付风险",
  BQ12: "小号风险",
  BQ13: "黄赌毒风险",
  BQ14: "账号风险",
  BQ15: "有多头借贷倾向",
  BQ16: "有信用逾期风险",
  BQ17: "欺诈",
  BQ18: "违法",
  BQ19: "刷单",
  BQ20: "信贷欺诈",
  BQ21: "支付欺诈",
  BQ22: "恶意骗贷",
  BQ23: "套现",
  BQ24: "境外欺诈",
  BQ25: "养号",
  BQ26: "盗号",
  BQ27: "欺诈作案APP用户",
  BQ28: "薅羊毛",
  BQ29: "黑产",
  BQ30: "欺诈团伙",
  BQ31: "黄赌毒",
  BQ32: "在逃嫌犯",
  BQ33: "法院失信",
  BQ34: "工商偷税漏税",
  BQ35: "股权冻结",
  BQ36: "无照经营",
  BQ37: "法院被执行人",
  BQ38: "行政处罚",
  BQ39: "疑似线上支付白户",
  BQ40: "疑似失联风险",

  // 个人涉诉
  zxgg: "执行公告",
  zxggId: "执行公告ID",
  address: "地址",
  body: "内容",
  caseNo: "案号",
  closeDate: "终本日期",
  court: "法院名称",
  proposer: "申请人",
  sortTime: "立案日期",
  title: "标题",
  yjCode: "依据文书",
  yjdw: "依据单位",
  partys: "当事人",
  datatype: "数据类型",

  cpws: "裁判文书",
  cpwsId: "裁判文书ID",
  body: "内容",
  caseNo: "案号",
  court: "法院",
  judge: "审判员",
  judgeResult: "判决结果",
  sortTime: "审结日期",
  title: "标题",
  yiju: "依据",
  partys: "当事人",
  datatype: "数据类型",

  shixin: "失信公告",
  shixinId: "失信公告ID",
  body: "内容",
  caseNo: "案号",
  court: "法院名称",
  postTime: "发布时间",
  sortTime: "立案时间",
  yiwu: "义务",
  yjCode: "依据文号",
  yjdw: "依据单位",
  partys: "当事人",
  datatype: "数据类型",

  sifacdk: "司法查冻扣",
  sifacdkId: "司法查冻扣ID",
  body: "正文",
  sortTime: "审结时间",
  eventDate: "事件日期",
  objectName: "标的名称",
  court: "审理法院",
  pname: "当事人",
  title: "标题",
  action: "资产类别",
  caseNo: "案号",
  objectType: "标的类型",
  postTime: "发布时间",
  money: "金额（元）",
  dataType: "数据类型",

  // 
  RuleSpecialList_c: "特殊名单验证反欺诈规则集",
  SpecialList_c: "特殊名单验证"
};



// WEBPACK FOOTER //
// ./src/views/fengkong/operation/common/staticMap.js